import tw, { styled } from 'twin.macro';

const Centered = styled.div(() => [
  tw`
    w-full h-full flex flex-col justify-center items-center
  `,
]);

export default Centered;
